import { combineReducers } from '@reduxjs/toolkit';
import personalInfoReducer from './Parts/PersonalInfo/personalInfoSlice';
import changePasswordReducer from './Parts/ChangePassword/changePasswordSlice';
import deleteAccountReducer from './Parts/DeleteAccount/deleteAccountSlice';

export const profileSettingsReducer = combineReducers({
  personalInfo: personalInfoReducer,
  changePassword: changePasswordReducer,
  deleteAccount: deleteAccountReducer,
});

export default profileSettingsReducer;
